import { selectChangeMessageForGoalsByZillIllustration } from '@UI/aside/asideGoalsByZillIllustration/asideGoalsByZillIllustrationSelectors';
import { selectChangeMessageForPracticalExampleReferences } from '@UI/aside/asidePracticalExampleReferences/asidePracticalExampleReferencesSelectors';
import { selectTitleNode } from '@newStore/documentUI/transformContent/genericSelectors';
import {
  loadPracticalExampleForZillIllustrations,
  loadZillGoalsForZillIllustrations,
} from '@newStore/zill/zillSagas';
import type { RootNodeConfig } from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { publishComponent } from '@nodeTypeConfig/helpers/editComponents/publishComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const ZILL_ILLUSTRATION: RootNodeConfig = {
  nodeSelector: selectTitleNode,
  information: {
    definiteArticle: false,
    single: 'Zill-illustratie',
    plural: 'Zill-illustraties',
    icon: require('../../../../img/icons/zillIllustration.svg'),
    category: 'ZILL',
  },

  onLoadActions: [loadZillGoalsForZillIllustrations(), loadPracticalExampleForZillIllustrations()],
  createModal: {
    authors: {
      addUser: true,
    },
  },
  websiteHref: null,
  tocTypes: [],
  buildingBlocks: [],
  edit: [
    titleComponent,
    authorsComponent,
    publishComponent,
    {
      component: 'practicalExampleReferences',
      reactComponent: 'AsidePracticalExampleReferences',
      label: 'Praktijkvoorbeeld',
      asideChangeMessageSelector: selectChangeMessageForPracticalExampleReferences,
    },
    {
      component: 'goalsByZillIllustration',
      reactComponent: 'AsideGoalsByZillIllustration',
      asideChangeMessageSelector: selectChangeMessageForGoalsByZillIllustration,
      label: 'Doel selecteren',
    },
  ],
  allowSuggestions: false,
  isCreatable: true,
  isSearchable: true,
};

export default ZILL_ILLUSTRATION;
